export default import.meta.ROLLDOWN_FILE_URL_qZZZ7EOcQU0bnm2SE9d1Ig